<template>
	<div class="agency-template" v-if="projectDataLoaded">

		<v-layout justify-end class="mr-3 no-print">
			<v-btn @click="exportTables">Eksportuj tabelę finansową</v-btn>
			<v-btn @click="print">Wydrukuj</v-btn>
		</v-layout>

		<agency-project-name
			v-model="projectData.title"
		></agency-project-name>

		<egranty-section-divider
			:text="'Nazwa naboru: ' + contestData.name"
			icon="assessment"
		></egranty-section-divider>
		<br>

		<v-layout row>
			<v-flex xs4>
				<AgencyChecksum
					:project-data="projectData"/>
			</v-flex>
			<v-flex xs4>
				<agency-choose-project-type-read-only-view
					:contest-id="contestData.id"
					v-model="projectData.projectType"
				></agency-choose-project-type-read-only-view>
			</v-flex>
			<v-flex xs4>
				<agency-minister-donation-read-only-view
					:donation-title="projectData.approved ? 'Kwota dofinansowania' : 'Kwota wnioskowana'"
					:donation-amount="projectData.approved ? projectData.ministerDonation : projectData.requestedDonation"
					:currency-code="projectData.currencyCode"
					:currency-loaded="currencyLoaded"
				></agency-minister-donation-read-only-view>
			</v-flex>
		</v-layout>

		<v-layout row>
			<v-flex x12>
				<agency-english-title-read-only-view
					v-model="projectData.englishTitle"
				></agency-english-title-read-only-view>
			</v-flex>
		</v-layout>

		<v-layout row>
			<v-flex xs6>
				<agency-priority-tree-read-only-view
					v-model="projectData.prioritiesData"
					:agency-id="projectData.agencyId"
					:readonly="true"
				></agency-priority-tree-read-only-view>
			</v-flex>
			<v-flex xs6>
				<agency-choose-funding
					:input="projectData.prioritiesData"
					v-model="projectData.financesData"
					:agency-id="projectData.agencyId"
					:readonly="true"
				></agency-choose-funding>
			</v-flex>
		</v-layout>

		<choose-d-a-c
      v-if="dacCodesEnabled"
			type="AGENCY_CONTEST"
			v-model="projectData.dacCodes"
			:readonly="true"
			:contest-id="$route.params.id"
		></choose-d-a-c>

		<agency-choose-beneficiaries-read-only-view
			class="agency-choose-beneficiaries"
			v-model="projectData.beneficiariesData"
		></agency-choose-beneficiaries-read-only-view>

		<agency-choose-actions
			class="agency-choose-actions"
			:taken-serial-numbers="projectData.takenSerialNumbers"
			v-model="projectData.actions"
			:readonly="true"
		></agency-choose-actions>

		<agency-choose-geographical-location-read-only-view
			class="choose-geographical-locations"
			v-model="projectData.locations"
		></agency-choose-geographical-location-read-only-view>

		<agency-actions-costs-read-only-view
			style="margin-top: 10px; margin-bottom: 10px"
			class="agency-actions-costs"
			v-model="projectData.costs"
			:actions="projectData.actions"
			:contest-id="contestData.id"
			:currency-code="projectData.currencyCode"
			ref="agencyActionCosts"
		></agency-actions-costs-read-only-view>
		<div v-for="(section, index) in genericMap" v-bind:key="index">
			<vue-form-generator
				:disabled="true"
				:name="'generator-'.concat(index)"
				:model="section.model"
				:schema="section.schema"
			/>
		</div>
		<div class="ma-5 project-signature-table">
			<v-layout row>
				<table style="width:100%; border: 1px solid black; border-collapse: collapse">
					<tr style="height: 35px; border: 1px solid black">
						<th class="ma-2"
							style="padding: 5px; font-size: 14px; width: 30%; text-align: center; border: 1px solid black">
							Miejscowość, data
						</th>
						<th style="padding: 5px; font-size: 14px; width: 70%; text-align: center; border: 1px solid black">
							Pieczęć i podpis kierownika placówki lub osoby pełniącej funkcję kierownika placówki (imię i
							nazwisko, funkcja)
						</th>
					</tr>
					<tr style="height: 60px">
						<td style="border: 1px solid black"></td>
						<td style="border: 1px solid black"></td>
					</tr>
				</table>

			</v-layout>
		</div>
	</div>
</template>

<script>
import Vue from "vue";
import EgrantySectionDivider from "../../../genericComponents/EgrantySectionDivider";
import AgencyChooseFunding from "./components/AgencyChooseFunding";
import ChooseDAC from "../offer/components/ChooseDAC";
import AgencyChooseActions from "./components/AgencyChooseActions";
import AgencyProjectName from "./components/AgencyProjectName";
import {Api} from "@/api";
import VueFormGenerator from "vue-form-generator";
import {genericFormUtil} from "@/utils/genericFormUtil";
import AgencyChecksum from "./components/AgencyChecksum";
import {XlsExport} from "@/api/generated/XlsExport";
import {CostsUtils} from "@/utils/CostsUtils";
import {Files} from "@/utils/Files";
import {Dates} from "@/utils/Dates";
import {AgencyContest} from "@/api/generated/AgencyContest";
import {Agency} from "@/api/generated/Agency";
import AgencyChooseProjectTypeReadOnlyView from "./readOnlyComponents/AgencyChooseProjectTypeReadOnlyView";
import AgencyPriorityTreeReadOnlyView from "./readOnlyComponents/AgencyPriorityTreeReadOnlyView";
import AgencyChooseBeneficiariesReadOnlyView from "./readOnlyComponents/AgencyChooseBeneficiariesReadOnlyView";
import AgencyChooseGeographicalLocationReadOnlyView
  from "./readOnlyComponents/AgencyChooseGeographicalLocationReadOnlyView";
import AgencyActionsCostsReadOnlyView from "./readOnlyComponents/AgencyActionsCostsReadOnlyView";
import AgencyEnglishTitleReadOnlyView from "./readOnlyComponents/AgencyEnglishTitleReadOnlyView";
import AgencyMinisterDonationReadOnlyView from "./AgencyMinisterDonationReadOnlyView";

Vue.use(VueFormGenerator);

export default {
  name: "AgencyProjectReadOnlyView",
  components: {
    AgencyMinisterDonationReadOnlyView,
    AgencyEnglishTitleReadOnlyView,
    AgencyActionsCostsReadOnlyView,
    AgencyChooseGeographicalLocationReadOnlyView,
    AgencyChooseBeneficiariesReadOnlyView,
    AgencyPriorityTreeReadOnlyView,
    AgencyChooseProjectTypeReadOnlyView,
    AgencyChecksum,
    AgencyChooseActions,
    ChooseDAC, AgencyChooseFunding,
    AgencyProjectName,
    EgrantySectionDivider,
  },

  computed: {
    genericMap() {
      if (this.contestData.persistentSchema === null || this.contestData.persistentModel === null) {
        return null;
      } else {
        let sectionsArray = [];

        for (let i = 0; i < this.contestData.persistentSchema.sections.length; i++) {
          if (!genericFormUtil.sectionShouldNotBeOnView(this.contestData.persistentSchema, i)) {
            sectionsArray.push(
                {
                  schema: this.applyGenericPersistentForm(i),
                  model: this.contestData.persistentModel.sections[i].fields,
                },
            );
          }
        }
        return sectionsArray;
      }
    },
  },

  methods: {

    applyGenericPersistentForm(sectionIndex) {
      let sections = this.contestData.persistentModel.sections;
      let schema = genericFormUtil.getSectionSchemaFromSchema(this.contestData.persistentSchema, sectionIndex, true);
      if (genericFormUtil.sectionSchemaContainsConditionalField(schema)) {
        let schemaValues = sections[sectionIndex].fields;
        return genericFormUtil.filterSchemaByConditionalFieldsValue(schema, schemaValues);
      } else {
        return schema;
      }
    },

    async loadData() {

      await Api.get(this,
          "/agency-contest/project-configuration"
          + "?contestId=" + this.contestData.id, successResponse => {
            this.contestData.persistentSchema = genericFormUtil.decodeSchema(successResponse.genericSchema);
            this.dacCodesEnabled = successResponse.dacCodesEnabled;
          }, () => {
          });
      // Pobranie danych oferty
      let path;
      if (this.$route.params.version) {
        path = "/agencyProject/data-version?agencyProjectId=".concat(this.projectData.id).concat("&version=".concat(this.$route.params.version));
      } else {
        path = "/agencyProject/data-readonly?agencyProjectId=".concat(this.projectData.id);
      }
      await Api.syncGet(
          this,
          path,
          response => {
            for (let field in response) {
              this.$set(this.projectData, field, response[field]);
            }
            this.contestData.persistentModel = genericFormUtil.decodeSchema(response.persistentGenericModel);
            this.projectDataLoaded = true;
          },
          errorResponse => this.$messagesBus.$emit("error", "Nie udało się wczytać projektu!", errorResponse),
      );

      if (!this.genericMap) return;
      this.genericMap.forEach(function (section, index) {
        genericFormUtil.addHeaderToFirstForm(
            "generator-".concat(index.toString()),
            "<h2 style=\"margin-left: 20px; page-break-after: avoid\">" + this.contestData.persistentSchema.sections[index].name + "</h2>",
        );
      }, this);

      AgencyContest.getContestName(this, this.contestData.id, successResponse => {
            this.contestData.name = successResponse.name;
          },
          errorResponse => {
            this.$messagesBus.$emit("error", "Nie udało się załadować nazwy konkursu", errorResponse);
          });

      Agency.getName(this, this.projectData.agencyId, successResponse => {
            this.projectData.agencyName = successResponse.name;
          },
          errorResponse => {
            this.$messagesBus.$emit("error", "Nie udało się załadować nazwy placówki", errorResponse);
          });

      Agency.getCurrencyCodeByAgency(this, this.projectData.agencyId, successResponse => {
            this.projectData.currencyCode = successResponse.currencyCode;
            this.currencyLoaded = true;
          },
          errorResponse => {
            this.$messagesBus.$emit("error", "Nie udało się załadować waluty placówki", errorResponse);
          });
    },

    exportTables() {
      const agencyActionCostsRef = this.$refs.agencyActionCosts;
      if (agencyActionCostsRef && agencyActionCostsRef.costs &&
          agencyActionCostsRef.costs.some(cost => !cost.actionId || !cost.paragraphId)) {
        this.$messagesBus.$emit("error", "Nie można wykonać eksportu. Tabela kosztów zawiera niekompletne rekordy. Uzupełnij lub usuń puste wiersze przed wydrukiem.");
        return;
      }
      XlsExport.postExportAgencyProjectTables(this, this.prepareAgencyExportData(this.projectData.id), successResponse => {
            let filename = "egranty_export_" + Dates.methods.getFilenameTimestamp() + "_raport.xlsx";
            this.$messagesBus.$emit("success", "Eksport danych wykonano do pliku " + filename, successResponse);
            Files.methods.downloadBlobResponse(successResponse, filename);
          },
          errorResponse => {
            this.$messagesBus.$emit("error", "Eksport nieudany", errorResponse);
          },
          {
            responseType: "blob",
          });
    },

    async print() {
      if (this.$route.params.version) {
        await Files.methods.downloadFileAsBlob(
            this,
            Files.methods.getAgencyProjectPrintUrl(
                this.contestData.id,
                this.projectData.agencyId,
                this.projectData.id,
                this.$route.params.version,
            ),
            "projekt.pdf",
        );
      } else {
        await Files.methods.downloadFileAsBlob(
            this,
            Files.methods.getAgencyProjectPrintUrl(
                this.contestData.id,
                this.projectData.agencyId,
                this.projectData.id,
            ),
            "projekt.pdf",
        );
      }
    },
  },

  mixins: [CostsUtils],

  data() {
    return {

      contestData: {
        id: this.$route.params.id,
        persistentSchema: null,
        persistentModel: null,
        name: "",
      },

      // tutaj pakujemy dane projektu
      projectData: {
        id: this.$route.params.projectId,
        genericModel: undefined,
        agencyName: "",
        currencyCode: "PLN"
      },

      projectDataLoaded: false,
      currencyLoaded: false,
      dacCodesEnabled: true,
    };
  },
  created() {
    this.loadData();
  },
};
</script>
